import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map, take, tap } from 'rxjs/operators';
import { isNil } from 'lodash';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private afAuth: AngularFireAuth) { }

  canActivate(next: ActivatedRouteSnapshot, route: RouterStateSnapshot) {
    if ( !isNil(this.afAuth.auth.currentUser)) {
      return true;
    }

    return this.afAuth.authState.pipe(
      take(1),
      map( user => !isNil(user)),
      tap( loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['login'], { queryParams: { returnUrl: route.url } });
        }
      })
    );
  }
}
